"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SaveRetrieveCartState_1 = require("./SaveRetrieveCartState");
require("./SaveRetrieveCart.scss");
var styles = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var icons = require("../../../styles/ccc-icons-cart.scss");
var ui_components_1 = require("@idp/ui-components");
var components_1 = require("@idp/duc/components");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var Checkout_cms_1 = require("../../../cms/Checkout.cms");
var Api_1 = require("../../../api/Api");
var Common = require("../../../utils/CommonUtilFuntions");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var utils_1 = require("@idp/ui-components/utils");
var localStyles = require("./SaveRetrieveCart.scss");
var MessageProps_1 = require("@idp/ui-components/components/atoms/Message/MessageProps");
var ReportingService_1 = require("../../../api/ReportingService");
var RetrieveCart_1 = require("./RetrieveCart");
var components_2 = require("@idp/duc/components");
var TextFieldProps_1 = require("@idp/duc/components/atoms/TextField/TextFieldProps");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var PrepaidCart_scss_1 = require("../../CartLob/PrepaidCart/PrepaidCart.scss");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var SaveRetrieveCart = /** @class */ (function (_super) {
    __extends(SaveRetrieveCart, _super);
    function SaveRetrieveCart(props) {
        var _this = _super.call(this, props) || this;
        _this.cmsContent = _this.saveCartCmsData();
        _this.custName = '';
        _this.emailFullRegex = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-][a-zA-Z0-9-]+\\.[a-zA-Z0-9-.][a-zA-Z0-9-.]+$');
        _this.requiredFieldText = 'Required field';
        _this.invalidCharText = 'Invalid character';
        _this.emptyString = '';
        _this.systemFailureMsg = 'Unexpected System failure';
        _this.state = new SaveRetrieveCartState_1.default();
        _this.api = new Api_1.default();
        _this.initializeEvents();
        _this.reportingService = new ReportingService_1.default();
        _this.thankYou = _this.thankYou.bind(_this);
        _this.onThankyouModalClose = _this.onThankyouModalClose.bind(_this);
        _this.showSaveErrorMsg = _this.showSaveErrorMsg.bind(_this);
        _this.triggerSaveCartModal = _this.triggerSaveCartModal.bind(_this);
        _this.toggleSaveCartModal = _this.toggleSaveCartModal.bind(_this);
        return _this;
    }
    SaveRetrieveCart.prototype.componentDidMount = function () {
        var _this = this;
        this.payload = this.props.data.payload;
        if (this.payload && this.payload.authUser) {
            this.isAuthUser = this.payload.authUser;
        }
        var saveCartLinks = this.payload.saveCartLinks;
        if (saveCartLinks) {
            saveCartLinks.forEach(function (val) {
                switch (val) {
                    case 'SAVE_CART':
                        _this.setState({ showSaveCartLink: true });
                        break;
                    case 'RETRIEVE_CART':
                        _this.setState({ showRetrieveCartLink: true });
                        break;
                }
            });
        }
    };
    SaveRetrieveCart.prototype.saveCartCmsData = function () {
        /**
         * Reading CMS data from local cms.ts file for cart view.
         * This will be changed when we integrate cartcheckout.cmsfeed.json
         * and legal content using AEM 6.1
         */
        if (!Common.isEmptyObject(this.cartSummaryCMSData)) {
            return this.cartSummaryCMSData;
        }
        this.cartSummaryCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common
            .saveRetrieveCart;
        return this.cartSummaryCMSData;
    };
    SaveRetrieveCart.prototype.triggerSaveCartModal = function () {
        this.toggleSaveCartModal(this.cmsContent.saveCartHeadingLabel, true);
    };
    SaveRetrieveCart.prototype.checkEmailInfoFormValid = function (postData, isExistingEmail, linkName) {
        var _this = this;
        if (this.state.email.length > 0) {
            var formDetails = this.getUpdateFormDetails(this.state.email);
            if (postData) {
                var saveCartRequestObj_1 = {
                    cartOrigin: 'IDP',
                    email: this.state.email,
                    overrideExistingCart: isExistingEmail,
                };
                this.reportingService.fireSaveCartSubmitEvent(false, undefined, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, linkName, saveCartRequestObj_1.email);
                this.api.saveCart(saveCartRequestObj_1).then(function (response) {
                    if (response && response.content
                        && response.content.status &&
                        response.content.status.toLowerCase() === 'success') {
                        _this.setState({
                            isExistingEmail: false,
                            showSaveCartModal: !_this.state.showSaveCartModal,
                            showThankyouModalFlag: true,
                        });
                        _this.reportingService.fireSaveCartSubmitEvent(false, undefined, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, saveCartRequestObj_1.email);
                        _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.THANK_YOU_MODAL);
                    }
                    else {
                        if (response && response.error && response.error.errorId) {
                            if (response.error.errorId === 'Cart-SC-1026') {
                                _this.errorcode = 'Cart-SC-1026';
                                _this.apierrormsg = response.error.message;
                                _this.setState({
                                    isExistingEmail: true,
                                    saveCartApiIsError: true,
                                    showThankyouModalFlag: false,
                                });
                            }
                            else if (response.error.errorId === 'Cart-SC-1027') {
                                _this.errorcode = 'Cart-SC-1027';
                                _this.apierrormsg = response.error.message;
                                _this.setState({
                                    isExistingEmail: false,
                                    saveCartApiIsError: true,
                                    showThankyouModalFlag: false,
                                });
                            }
                        }
                        _this.reportingService.fireSaveCartSubmitEvent(true, _this.apierrormsg, _this.errorcode, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, saveCartRequestObj_1.email);
                    }
                }).catch(function (err) {
                    _this.errorcode = '00000';
                    _this.setState({
                        isExistingEmail: false,
                        showThankyouModalFlag: false,
                    });
                    _this.reportingService.fireSaveCartSubmitEvent(true, _this.systemFailureMsg, '400', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, saveCartRequestObj_1.email);
                });
                this.props.events.emailInfoUpdated(formDetails);
            }
            this.setState({
                isSubmitBtnDisabled: false,
                readonlyMode: true,
            });
        }
        else {
            this.setState({
                isSubmitBtnDisabled: true,
            });
        }
    };
    SaveRetrieveCart.prototype.getUpdateFormDetails = function (emailAddress) {
        var obj = { email: emailAddress };
        return obj;
    };
    SaveRetrieveCart.prototype.initializeEvents = function () {
        var _this = this;
        this.emailEvents = {
            onBlur: function (value) {
                _this.emailEventsBlurActions(value);
            },
            onChange: function (event) {
                _this.setState({
                    email: event.currentTarget.value,
                    emailErrTxt: '',
                    isEmailinValid: false,
                }, function () {
                    _this.checkEmailValidOrNot();
                });
            },
            onClear: function (value, event) {
                _this.setState({
                    email: '',
                    emailErrTxt: '',
                    isEmailinValid: false,
                }, function () {
                    _this.checkEmailValidOrNot();
                });
            },
            onKeyPress: function (value, e) {
                _this.emailEventsKeyPressActions(value, e);
            },
        };
    };
    SaveRetrieveCart.prototype.emailEventsKeyPressActions = function (value, e) {
        var regex = new RegExp('^[\\w-_.@]$');
        if (!regex.test(e.key)) {
            this.setState({
                emailErrTxt: this.invalidCharText,
                isEmailinValid: true,
            });
            e.preventDefault();
        }
        else {
            this.setState({
                emailErrTxt: '',
                isEmailinValid: false,
            });
        }
    };
    SaveRetrieveCart.prototype.emailEventsBlurActions = function (value) {
        var _this = this;
        if (value) {
            value = value.trim();
            if (!this.emailFullRegex.test(value)) {
                this.setState({
                    emailErrTxt: this.cmsContent.emailErrText,
                    isEmailinValid: true,
                });
            }
            else {
                this.setState({
                    email: value,
                    emailErrTxt: '',
                    emailUpdated: true,
                    isEmailinValid: false,
                }, function () {
                    _this.checkEmailValidOrNot();
                });
            }
        }
        else {
            this.setState({
                emailErrTxt: this.requiredFieldText,
                isEmailinValid: true,
            });
        }
    };
    // NEed to refactor
    SaveRetrieveCart.prototype.checkEmailValidOrNot = function () {
        if (this.emailFullRegex.test(this.state.email)) {
            this.setState({
                isSubmitBtnDisabled: false,
            });
        }
        else {
            this.setState({
                isSubmitBtnDisabled: true,
            });
        }
    };
    SaveRetrieveCart.prototype.render = function () {
        var _a;
        this.cmsContent = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common
            .saveRetrieveCart;
        this.commonFieldsCmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.commonFields;
        this.requiredFieldText = this.commonFieldsCmsData.requiredFieldInputBox;
        var isAccessPromo = (_a = CartUtilFunctions_1.getAcpAccessPromo()) === null || _a === void 0 ? void 0 : _a.isAccessPromo;
        return (React.createElement(React.Fragment, null,
            this.state.showThankyouModalFlag && this.thankYou(),
            React.createElement("span", { className: localStyles.linksInnerContainer },
                this.state.showSaveCartLink && !isAccessPromo && this.saveCartModal(),
                this.state.showRetrieveCartLink && this.retrieveCartModal())));
    };
    SaveRetrieveCart.prototype.saveCartModal = function () {
        return (React.createElement("span", { className: localStyles.linkWithIcon },
            React.createElement(components_1.Link, { kind: "textPlain", className: this.props && this.props.options &&
                    this.props.options.isPrepaidExpView ? PrepaidCart_scss_1.expupLinkSmall : CartConfiguration_scss_1.cartLinkMedium, onClick: this.toggleSaveCartModal.bind(this, this.cmsContent.saveCartHeadingLabel, true), testId: utils_1.default('Savecart', 'Link', 'Save_Cart') }, this.cmsContent.saveCartCTALabel),
            React.createElement(ui_components_1.Modal, { testId: utils_1.default('Savecart', 'Modal', 'Save_Cart_Modal'), options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showSaveCartModal,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                }, events: { onClose: this.toggleSaveCartModal.bind(this, ReportingService_1.CheckoutLinkNames.MODAL_CLOSE, false) } },
                React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.saveCartModalHeadingLabel }, options: { className: CartConfiguration_scss_1.rennyModalTitle } })),
                    this.state.isExistingEmail ? this.existingCart() : this.savingCart()))));
    };
    SaveRetrieveCart.prototype.retrieveCartModal = function () {
        var _this = this;
        if (this.props.data.payload) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", null,
                    React.createElement("div", { className: localStyles.seperator })),
                React.createElement("span", { className: localStyles.linkWithIcon },
                    React.createElement(RetrieveCart_1.default, { events: {
                            onModalClose: function () {
                                _this.setState({ showRetrieveCartModal: false });
                            },
                        }, data: { triggerCart: this.state.showRetrieveCartModal } }))));
        }
        else {
            return React.createElement(React.Fragment, null, " ");
        }
    };
    SaveRetrieveCart.prototype.showSaveErrorMsg = function () {
        if (this.state.saveCartApiIsError) {
            var msgText = this.cmsContent.savingYourCartErrTxt || this.apierrormsg;
            var iconType = MessageProps_1.MessageType.ERROR;
            if (this.errorcode === 'Cart-SC-1026') {
                msgText = this.cmsContent.existingSavedCartErrTxt;
                iconType = MessageProps_1.MessageType.INFO;
            }
            else if (this.errorcode === 'Cart-SC-1027') {
                msgText = this.cmsContent.savingYourCartErrTxt;
                iconType = MessageProps_1.MessageType.ERROR;
            }
            if (this.state.errorMsgForAuthFlow) {
                this.props.events.authSaveErrorMsg(msgText, iconType);
                this.setState({ errorMsgForAuthFlow: false });
                return (React.createElement(React.Fragment, null));
            }
            else {
                return (React.createElement("div", { className: localStyles.errorMsgContainer },
                    React.createElement(components_2.Alert, { closeable: false, onWhite: true, testId: 'Save_Cart_Error_InfoMsg', type: iconType === MessageProps_1.MessageType.INFO ? 'info' : 'error' }, msgText)));
            }
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    SaveRetrieveCart.prototype.savingCart = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.showSaveErrorMsg(),
            React.createElement("p", { className: localStyles.savecartContainer }, this.cmsContent.saveCartModalBodyContainer),
            CartUtilFunctions_1.isPreScreenCreditCheck() &&
                React.createElement("p", { dangerouslySetInnerHTML: { __html: this.cmsContent.preScreenDisclaimer }, id: "disclaimer_text", className: localStyles.preScreenDisclaimer }),
            React.createElement("div", null,
                React.createElement("div", { id: "email", className: [
                        styles.pt3,
                        this.state.isEmailinValid ? styles.showErrMsg : '',
                    ].join(' ') },
                    React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.emailAddressLabel }, testId: 'CHKT_acctSecurity_Label_Passcode', options: { className: localStyles.emailAddressLabel } }),
                    React.createElement(components_1.TextField, { data: { input: this.state.email, name: 'securityPassCode' }, options: {
                            accessibility: this.cmsContent.saveCartHeadingLabel,
                            maxLength: 50,
                            type: TextFieldProps_1.TextFieldType.TEXT,
                        }, events: this.emailEvents, testId: utils_1.default('TextField', 'acctSecurity_passCode_TextField') }),
                    React.createElement("div", { className: styles.errTxt },
                        React.createElement("i", { "aria-label": this.commonFieldsCmsData.iconAccessibilityAriaLabel, className: [icons.cccIconCart, icons.cccIconCartBadgealert].join(' '), "aria-hidden": "true" }),
                        React.createElement("span", { "aria-live": "assertive", role: "alert" }, this.state.emailErrTxt)))),
            React.createElement("div", { className: localStyles.noteText }, this.cmsContent.emailNoteMessageLabel),
            React.createElement("div", { className: localStyles.buttonsAlignment },
                React.createElement(components_1.Button, { kind: "secondary", testId: utils_1.default('Button', '_billPreference_Button'), onClick: this.toggleSaveCartModal.bind(this, this.cmsContent.cancelCTALabel, false), className: [localStyles.modalButtons].join() }, this.cmsContent.cancelCTALabel),
                React.createElement(components_1.Button, { kind: "primaryBlue", testId: utils_1.default('Button', '_billPreference_Button'), 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () {
                        return _this.checkEmailInfoFormValid(true, _this.state.isExistingEmail, _this.cmsContent.saveCartCTALabel);
                    }, disabled: this.state.isSubmitBtnDisabled, className: [localStyles.modalButtons].join() }, this.cmsContent.saveCartCTALabel)),
            React.createElement("div", { className: localStyles.privacyPolicyText },
                this.cmsContent.privacyNoteMessageLable,
                React.createElement(components_1.Link, { kind: "textPlain", 
                    // tslint:disable-next-line: jsx-no-bind
                    onClick: this.onPolicyClick.bind(this), testId: utils_1.default('PrivacyPolicy', 'Link', "Privacy_Policy") }, 'Privacy Policy'))));
    };
    SaveRetrieveCart.prototype.existingCart = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: localStyles.errorContainer }, this.showSaveErrorMsg()),
            React.createElement("div", null,
                React.createElement("div", { className: localStyles.noteText },
                    this.cmsContent.replaceItemsMessageLabel,
                    React.createElement("b", null,
                        " ",
                        this.cmsContent.replaceSavedCartCTALabel),
                    React.createElement("a", null, ".")),
                React.createElement("div", { className: localStyles.noteText },
                    this.cmsContent.retrieveCartMessageLabel,
                    React.createElement("b", null,
                        " ",
                        this.cmsContent.retrieveSavedCartCTALabel),
                    React.createElement("a", null, ".")),
                React.createElement("div", null,
                    React.createElement(components_1.Button, { kind: "primaryBlue", testId: utils_1.default('Button', '_billPreference_Button'), 
                        // onClick={this.toggleSaveCartModal.bind(this, this.cmsContent.cancelCTALabel, false)}
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () {
                            return _this.checkEmailInfoFormValid(true, _this.state.isExistingEmail, _this.cmsContent.saveCartCTALabel);
                        }, className: [localStyles.modalButtons].join(), disabled: false }, this.cmsContent.replaceSavedCartCTALabel),
                    React.createElement(components_1.Button, { kind: "primaryBlue", testId: utils_1.default('Button', '_billPreference_Button'), 
                        // tslint:disable-next-line: jsx-no-bind
                        onClick: this.toggleRetriveCartModal.bind(this), disabled: false, className: [localStyles.modalButtons1].join() }, this.cmsContent.retrieveSavedCartCTALabel)))));
    };
    SaveRetrieveCart.prototype.thankYou = function () {
        var _this = this;
        var daysSpan = this.cmsContent.thankYou.daysLabel;
        return (React.createElement("div", null, this.state.showThankyouModalFlag &&
            React.createElement(ui_components_1.Modal, { testId: "Modal_Save_Cart_Thankyou", options: {
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showThankyouModalFlag,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                }, events: { onClose: this.onThankyouModalClose }, accessibilityText: "_Save_Cart_Thankyou" },
                React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                    React.createElement("div", { className: localStyles.thankYouLabel },
                        React.createElement("span", { className: localStyles.iconCheck },
                            React.createElement("i", { tabIndex: 0, role: "img", "aria-label": "Icon", className: [icons.cccIconCart, icons.cccIconCartCheck, localStyles.checkIcon].join(' '), "aria-hidden": "true" })),
                        React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.thankYou.allSetLabel }, options: { className: CartConfiguration_scss_1.rennyModalTitle } }),
                        !this.isAuthUser ?
                            React.createElement("span", { className: localStyles.authName }, "!") :
                            React.createElement("span", { className: localStyles.authName },
                                ", ",
                                this.custName,
                                "!")),
                    React.createElement("div", null, !this.isAuthUser ?
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.thankYou.emailNotificationLabel }, options: { className: localStyles.emailNotification, size: LabelProps_1.LabelSizes.LARGEBODY } }),
                            React.createElement(ui_components_1.Label, { data: { text: this.state.email }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18 } }))
                        : React.createElement("span", null,
                            " ",
                            this.emptyString,
                            " ")),
                    React.createElement("div", { className: localStyles.saveCartDaysLabel },
                        React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.thankYou.saveCartDaysLabel }, options: { size: LabelProps_1.LabelSizes.LARGEBODY } }),
                        React.createElement("span", { className: localStyles.noOfDays }, " 60 "),
                        React.createElement(ui_components_1.Label, { data: { text: daysSpan }, options: { size: LabelProps_1.LabelSizes.LARGEBODY } })),
                    React.createElement("div", { className: localStyles.retrieveLabel }, this.isAuthUser ?
                        React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.thankYou.retrieveLabel }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } }) : React.createElement("span", null,
                        " ",
                        this.emptyString,
                        " ")),
                    React.createElement("div", { className: localStyles.noteLabel }, this.isAuthUser ?
                        React.createElement(ui_components_1.Label, { data: { text: this.cmsContent.thankYou.noteLabel }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } }) : React.createElement("span", null,
                        " ",
                        this.emptyString,
                        " ")),
                    React.createElement("p", { className: localStyles.thankyouPromoSection },
                        React.createElement("strong", null, this.cmsContent.thankYou.headsupLabel),
                        React.createElement("span", null, this.cmsContent.thankYou.promoLabel)),
                    React.createElement("div", { className: localStyles.continueButtonCta },
                        React.createElement(components_1.Button, { kind: "primaryBlue", 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () {
                                _this.onThankyouModalClose();
                            }, testId: utils_1.default('Button', '_Save_Cart_thankYou') }, this.cmsContent.thankYou.continueCtaLabel))))));
    };
    SaveRetrieveCart.prototype.onThankyouModalClose = function () {
        this.setState({ showThankyouModalFlag: false });
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    SaveRetrieveCart.prototype.toggleSaveCartModal = function (value, isSaveCart) {
        var _this = this;
        this.reportingService.fireLinkClickEvent(value, isSaveCart ? ReportingService_1.PageUrls.SAVE_CART_URL : ReportingService_1.PageUrls.CART_PAGE);
        var saveCartRequestObj;
        if (this.isAuthUser) {
            saveCartRequestObj = {};
            this.api.saveCart(saveCartRequestObj).then(function (response) {
                if (response && response.content
                    && response.content.status &&
                    response.content.status.toLowerCase() === 'success') {
                    if (response.content.payload && response.content.payload.firstName) {
                        _this.custName = response.content.payload.firstName;
                    }
                    _this.setState({
                        errorMsgForAuthFlow: false,
                        saveCartApiIsError: false,
                        showSaveCartModal: false,
                        showThankyouModalFlag: true,
                    });
                }
                else {
                    if (response && response.error && response.error && response.error.errorId) {
                        _this.setState({
                            errorMsgForAuthFlow: true,
                            saveCartApiIsError: true,
                            showSaveCartModal: false,
                            showThankyouModalFlag: false,
                        }, function () {
                            _this.showSaveErrorMsg();
                        });
                        _this.errorcode = response.error.errorId;
                        _this.apierrormsg = response.error.message;
                    }
                }
            }).catch(function (err) {
                _this.setState({
                    errorMsgForAuthFlow: true,
                    saveCartApiIsError: true,
                    showSaveCartModal: false,
                    showThankyouModalFlag: false,
                }, function () {
                    _this.showSaveErrorMsg();
                });
            });
        }
        else {
            this.setState(__assign(__assign({}, this.state), { email: '', emailErrTxt: '', isEmailinValid: false, isExistingEmail: false, isSubmitBtnDisabled: true, saveCartApiIsError: false, showSaveCartModal: !this.state.showSaveCartModal }));
        }
    };
    SaveRetrieveCart.prototype.toggleRetriveCartModal = function () {
        this.setState(__assign(__assign({}, this.state), { showRetrieveCartModal: !this.state.showRetrieveCartModal, showSaveCartModal: !this.state.showSaveCartModal }));
    };
    SaveRetrieveCart.prototype.onPolicyClick = function () {
        var _this = this;
        this.reportingService.fireLinkClickWithOutPageLoad('Privacy Policy', ReportingService_1.PageUrls.PRIVACY_POLICY);
        setTimeout(function () {
            window.open(_this.cmsContent.privacyPolicyLinkLabel, '_blank');
        }, 1000);
    };
    return SaveRetrieveCart;
}(React.Component));
exports.default = SaveRetrieveCart;
//# sourceMappingURL=SaveRetrieveCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/SaveRetrieveCart.js
// module id = 2268
// module chunks = 8